export const SELECTED_COUNTRY = "selected_country"; // Last selected country on a location form
export const SELECTED_STATE = "selected_state"; // Last selected state on a location form
export const SELECTED_CITY = "selected_city"; // Last selected city on a location form
export const SELECTED_DOCUMENT_TYPE = "selected_document_type"; // Last selected document type on a billing form
export const SELECTED_BANK = "selected_bank"; // Last selected bank on a billing form
export const SELECTED_USER_TYPE = "selected_user_type"; // Last selected user type on a billing form
